export default __webpack_public_path__ + "img/6151daf78f8356673b6cc484b0bbcd64.png";